// src/components/SourceSystemDataGrid.tsx
import React, { Component, ChangeEvent } from 'react';
import { Table, Button, Form, Card } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';



// Define the shape of the grid data
interface SourceSystemData {
  id: string;
  code: string;
  name: string;
}

interface SourceSystemDataGridProps {
  data: SourceSystemData[];
  handleSrcSystemValueChanges: (data: any) => void;
}

interface SourceSystemDataGridState {
  data: SourceSystemData[];
}


class SourceSystemDataGrid extends Component<SourceSystemDataGridProps, SourceSystemDataGridState> {
  constructor(props: SourceSystemDataGridProps) {
    super(props);
	let data = this.props.data;
	if (data){
		let ix = 0;
		for (const d of data){
			if (!d.id){
				d['id'] = (ix++) + '';
			}
		}
	}
    this.state = {
	  data: data,
    };
  }
  
  componentDidUpdate(prevProps: SourceSystemDataGridProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }
  }

  // Handle input change for editable cells
  handleInputChange = (id: string, field: keyof SourceSystemData, value: string | number) => {
    const updatedData = this.state.data.map((row) =>
      row.id === id ? { ...row, [field]: value } : row
    );
    this.setState({ data: updatedData });
	//this.props.handleSrcSystemValueChanges(updatedData);
  };

  // Add a new row
  addRow = () => {
    const newRow: SourceSystemData = {
      id: Date.now() + '',
      code: '',
      name: '',
    };
    this.setState((prevState) => ({
      data: [...prevState.data, newRow],
    }));
  };

  // Delete a row by id
  deleteRow = (id: string) => {
    const updatedData = this.state.data.filter((row) => row.id !== id);
    this.setState({ data: updatedData });
	//this.props.handleSrcSystemValueChanges(updatedData);
  };

  render() {
    return (
	<Card>
		<Card.Header>
			<div className="d-flex justify-content-between align-items-center" >
				<h6>{'SourceSystem values'}</h6>
				<div className="d-flex justify-content-end align-items-center">
                    <div className="d-flex justify-content-between align-items-center">
                        <Button variant="primary" size="sm" onClick={() => this.addRow()} style={{marginRight:'10px'}}>
                          Add
                        </Button>
                        <Button variant="primary" size="sm" onClick={() =>this.props.handleSrcSystemValueChanges(this.state.data)}>
                          Update
                        </Button>
                    </div>
				</div>
			</div>
		</Card.Header>
	  <Card.Body style={{ maxHeight: '2220px', overflowY: 'auto' }}>
		
	  
		<div style={{ height: '400px', overflowY: 'scroll' }}>
			<Table>
			  <thead className="sticky-header">
				<tr>
				  <th>CODE</th>
				  <th>NAME</th>
				  <th></th>
				</tr>
			  </thead>
			  <tbody>
				{this.state.data.map((row) => (
				  <tr key={row.id}>
					<td style={{border:'0'}}>
					  <Form.Control
						type="text"
						value={row.code}
						onChange={(e: ChangeEvent<HTMLInputElement>) =>
						  this.handleInputChange(row.id, 'code', e.target.value)
						}
					  />
					</td>
					<td style={{border:'0'}}>
					  <Form.Control
						type="text"
						value={row.name}
						onChange={(e: ChangeEvent<HTMLInputElement>) =>
						  this.handleInputChange(row.id, 'name', e.target.value)
						}
					  />
					</td>
					<td style={{border:'0'}}>
					  
						<Button 
						  variant="" 
						  style={{ padding: 0, marginTop: '-10px', marginLeft:'5px' }} 
						  onClick={() => this.deleteRow(row.id)}
						>
						  <FontAwesomeIcon icon={faTrash} style={{ fontSize: '12px', color: 'grey' }}  />
						</Button>
					</td>
				  </tr>
				))}
			  </tbody>
			</Table>
			
		 </div>
	  </Card.Body>
	  </Card>
    );
  }
}

export default SourceSystemDataGrid;
